// Fondo dinámico de círculos blureados — usado en el AutoPlaceholder
// de las cards Modelo/Pose (mobile) y en los tiles "Automático" de los
// pickers (ModelPicker / FondoPicker). Tres círculos de color drift
// animados continuamente.
//
// Prop `pauseOnDesktopUnselected`:
//   • true  → la animación se pausa en desktop (md:) si `selected=false`.
//             En mobile siempre corre. En desktop selected, corre.
//   • false → la animación corre siempre, independiente del viewport.

import React from 'react';

interface AnimatedBlurBgProps {
  /** Si true, se pausa la animación en desktop cuando no está seleccionado. */
  pauseOnDesktopUnselected?: boolean;
  /** Estado de selección — relevante sólo cuando `pauseOnDesktopUnselected`. */
  selected?: boolean;
  /** Opcional: overlay translúcido encima de los círculos (e.g. para
   *  ayudar contraste de texto blanco sobre el fondo). */
  overlay?: 'dark' | 'light' | 'none';
}

export const AnimatedBlurBg: React.FC<AnimatedBlurBgProps> = ({
  pauseOnDesktopUnselected = false,
  selected = false,
  overlay = 'none',
}) => {
  // Cuando `pauseOnDesktopUnselected` y NO está seleccionado, pausamos
  // en desktop via `md:[animation-play-state:paused]`. Mobile siempre
  // corre (no override).
  const pauseClass =
    pauseOnDesktopUnselected && !selected
      ? 'md:[animation-play-state:paused]'
      : '';
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* Blue — empujado hacia afuera por la izquierda. La opacidad la
          controla la animación `animate-blur-1` (drift + opacity-pulse). */}
      <div
        className={`absolute rounded-full blur-2xl animate-blur-1 ${pauseClass}`}
        style={{
          width: '60%',
          height: '60%',
          backgroundColor: 'var(--brand-primary)',
          left: '-20%',
          top: '15%',
        }}
      />
      {/* Cyan — empujado hacia afuera por la derecha-arriba. */}
      <div
        className={`absolute rounded-full blur-2xl animate-blur-2 ${pauseClass}`}
        style={{
          width: '70%',
          height: '70%',
          backgroundColor: '#06B6D4',
          right: '-20%',
          top: '-10%',
        }}
      />
      {/* Magenta — empujado hacia abajo, fuera del borde inferior. */}
      <div
        className={`absolute rounded-full blur-2xl animate-blur-3 ${pauseClass}`}
        style={{
          width: '75%',
          height: '75%',
          backgroundColor: '#EC4899',
          left: '15%',
          bottom: '-25%',
        }}
      />
      {overlay !== 'none' && (
        <div
          className={`absolute inset-0 ${
            overlay === 'dark' ? 'bg-black/20' : 'bg-white/20'
          }`}
        />
      )}
    </div>
  );
};
